<template>
    <transition name="fade">
        <div class="cookiebar" v-if="visible">
            <div class="container">
                <div class="row d-flex justify-content-between align-items-center cookiebar-content">
                    <div class="col">
                        <p>Deze website maakt gebruik van cookies. Bij gebruik van deze website ga je akkoord met de cookies.
                            <a href="/privacy-statement" target="_blank" rel="noopener">Meer informatie over de cookies</a>.
                        </p>
                    </div>
                    <div class="col-12 col-sm-auto pt-3 pt-sm-0">
                        <button class="close" @click="close()">Verberg melding</button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
export default {
    data() {
        return {
            visible: false,
        };
    },
    mounted() {
        if (!this.$cookie.get('cookies')) {
            this.visible = true;
        }
    },
    methods: {
        close() {
            this.$cookie.set('cookies', true, {expires: '1Y'});
            this.visible = false;
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/components/CookieBar.vue